import { isPlatformBrowser, NgClass, NgStyle } from "@angular/common";
import {
  Component,
  HostListener,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  ViewEncapsulation
} from "@angular/core";
import { CmsData } from "@dotcom-frontend/data";
import { DynamicComponent } from "../../utils/dynamic-loader/dynamic.component";
import {
  LgGridColDirective,
  LgGridContainerDirective,
  LgGridRowDirective,
  LgTableBodyComponent,
  LgTableCellComponent,
  LgTableComponent,
  LgTableHeadCellComponent,
  LgTableHeadComponent,
  LgTableRowComponent
} from "@legal-and-general/canopy";
import { LoaderComponent } from "../../utils/dynamic-loader/loader.component";
import { Store } from "@ngrx/store";
import { GlobalState } from "../../../store/global/global.reducer";
import { Observable } from "rxjs";
import { selectPageTitle } from "../../../store/global/global.selectors";
import { DynamicComponentItem } from "../../utils/dynamic-loader/dynamic-component-item";
import { ComponentLoaderService } from "../../../services/component-loader/component-loader.service";
import { ButtonComponent } from "../../globals/Button/Button.component";

@Component({
  selector: "dotcom-frontend-table",
  templateUrl: "./TableBlock.component.html",
  encapsulation: ViewEncapsulation.None,
  styleUrl: "./TableBlock.component.scss",
  standalone: true,
  imports: [
    LoaderComponent,
    LgGridRowDirective,
    LgGridContainerDirective,
    LgGridColDirective,
    ButtonComponent,
    LgTableComponent,
    LgTableHeadComponent,
    LgTableBodyComponent,
    LgTableRowComponent,
    LgTableCellComponent,
    LgTableHeadCellComponent,
    NgStyle,
    NgClass
  ]
})
export class TableBlockComponent implements DynamicComponent, OnInit {
  @Input() data: CmsData | undefined;
  pageTitle = "";
  name: string | undefined;
  pageTitle$: Observable<string> = this.store.select(selectPageTitle);
  headingComponent: DynamicComponentItem | undefined;
  followUpButtons: any;
  headCells: any = [];
  tableRows: any = [];
  tableCells: any = [];
  tableBodyRows: any;
  headerPosition = "";
  tableColour = "";
  tableWidthPercentage: number | undefined;
  isMobile: boolean | undefined;
  isBrowser = isPlatformBrowser(this.platformId);
  tableHeader = "";
  isVerticalHeader = false;

  constructor(
    private store: Store<{ global: GlobalState }>,
    private componentLoaderService: ComponentLoaderService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.pageTitle$.subscribe((title) => {
      this.pageTitle = title;
    });
  }

  @HostListener("window:resize", ["$event"])
  onResize() {
    this.checkIfMobile();
  }

  async ngOnInit() {
    if (this.data) {
      this.checkIfMobile();

      if (this.data["headingBlock"]) {
        this.headingComponent = await this.componentLoaderService.loadComponent(
          "Heading",
          "globals",
          {
            headingBlock: this.data["headingBlock"]
          }
        );
      }

      if (this.data["followUpButton"]) {
        this.followUpButtons = [];
        for (const button of this.data["followUpButton"]) {
          const buttonComponent =
            await this.componentLoaderService.loadComponent(
              "Button",
              "globals",
              {
                ...button,
                blockId : this.data["contentLink"]["id"],
                adobeData: {
                  interactionContainer: "Table Block",
                  interactionLink: button["href"],
                  interactionName: button["text"],
                  interactionPage: this.pageTitle,
                  interactionRegion: "",
                  interactionType: "ButtonClick",
                  interactionDetails: ""
                }
              }
            );
          this.followUpButtons.push(buttonComponent);
        }
      }

      this.headCells =
        this.data["tableRows"][0]["contentLink"]["expanded"]["tableCells"];

      this.tableRows = this.data["tableRows"];

      this.tableBodyRows = this.tableRows.slice(1);

      this.headerPosition = this.data["tableHeader"];

      this.tableColour = this.data["tableColour"];

      this.tableWidthPercentage = this.data["tableWidthPercentage"];

      this.tableHeader = this.data["tableHeader"];

      if (this.tableHeader === "vertical") {
        this.isVerticalHeader = true;
      }
    }
  }

  checkIfMobile() {
    if (this.isBrowser) {
      this.isMobile = window.innerWidth < 768;
    }
  }
}
